import Axios, { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

import {
    CultureSettings,
    Currency,
} from "store/environments/tenants/culture-settings/culture-settings-types";

export const loadCultureSettings = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[CultureSettings | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.get(
        `environments/${environmentId}/tenants/${tenantId}/culture-settings`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const updateCultureSettings = async (
    environmentId: string,
    tenantId: string,
    cultureSettings: CultureSettings
): Promise<[CultureSettings | null, number]> => {
    if (!environmentId || !tenantId || !cultureSettings) {
        return defaultErrorResponse;
    }

    const response = await API.put(
        `environments/${environmentId}/tenants/${tenantId}/culture-settings`,
        cultureSettings
    );

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const loadCurrencies = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[Currency[] | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.get(
        `environments/${environmentId}/tenants/${tenantId}/culture-settings/currencies`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadSupportedCultures = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[string[] | null, number]> => {
    const response = await API.get(
        `environments/${environmentId}/tenants/${tenantId}/culture-settings/cultures/supported`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadCultures = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[string[] | null, number]> => {
    const response = await API.get(
        `environments/${environmentId}/tenants/${tenantId}/culture-settings/cultures`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};
